export default __webpack_public_path__ + "static/ballburr-e7f8e72d47a0516e251e821646d9b4a1.png";